export const PATH_HOME = '/'
export const PATH_OCP = '/ocp/'
export const PATH_ACCOUNT = '/account/'
